module.exports = __webpack_public_path__ + "static/media/feather-sprite.92e938d9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vendor/feathericons/feather-sprite.svg
// module id = 417
// module chunks = 0